import React, { useState } from "react";
import {
  Box,
  Modal,
  Typography,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import { toast } from "react-toastify";
const OtpModal = ({ open, handleClose,handleVerifyOtp }) => {
  const [otp, setOtp] = useState(Array(6).fill(""));

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // only numbers
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // auto focus next input
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };
  const handleSubmit = () => {
  const enteredOtp = otp.join(""); // Join array into string
    handleVerifyOtp(enteredOtp);
      setOtp(Array(6).fill("")); // Reset OTP inputs     
       handleClose(); // Close the modal
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 3,
          p: 4,
          width: 400,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Enter OTP
        </Typography>
        <Stack direction="row" justifyContent="center" spacing={1} mb={3}>
          {otp.map((digit, index) => (
            <TextField
              key={index}
              id={`otp-${index}`}
              value={digit}
              onChange={(e) => handleChange(e, index)}
              inputProps={{
                maxLength: 1,
                style: { textAlign: "center", fontSize: "1.5rem" },
              }}
              sx={{
                width: 50,
              }}
            />
          ))}
        </Stack>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            backgroundColor: "#FF6B00",
            borderRadius: "20px",
            px: 4,
            py: 1,
            "&:hover": {
              backgroundColor: "#e55f00",
            },
          }}
        >
          Submit
        </Button>
       
      </Box>
    </Modal>
  );
};

export default OtpModal;
